module.exports = __webpack_public_path__ + "img/logo.e6a374ba.png";